module.exports = __webpack_public_path__ + "img/death-artist.78e3a7b6.png";